// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2HRar","col":"CardReaderDesc_col__1F7Nb","label":"CardReaderDesc_label__2MDS3"};